var watson = {
    debug: false,
    ewtType: 'wvpage',
    dataAttr: 'watson-name',
    pageLoadTriggerClass: 'watson-load',
    clickTriggerClass: '.watson-click',
    blurTriggerClass: '.watson-blur',
    init: function () {
        this.blur();
        this.click();
        this.load();
    },
    click: function() {
        $('body').on('click', watson.clickTriggerClass, function () {
            var ewtName = $(this).data(watson.dataAttr);
            watson.track(ewtName);
        });
    },
    load: function() {
        var $body = $('body'),
            triggerPageLoad = $body.hasClass(watson.pageLoadTriggerClass),
            ewtName;

        if (triggerPageLoad === true) {
            ewtName = $body.data(watson.dataAttr);
            $(document).on('ewtready', function() {
                watson.track(ewtName);
            });
        }
    },
    blur: function() {
        $(watson.blurTriggerClass).blur(function() {
            var value = $(this).val();

            if (value) {
                var ewtName = $(this).data(watson.dataAttr);
                watson.track(ewtName);
            }
        });
    },
    track: function (ewtName) {
        if (typeof ewt !== 'undefined') {
            try {
                if (watson.debug === true) {
                    console.log('name: ' + ewtName, ', type: ' + watson.ewtType);
                }
                ewt.trackLink({name: ewtName, type: watson.ewtType});
            } catch(err) {
                console.log(err);
            }
        }
    }
};

var supporterInteraction = {
    clickTriggerClass: '.interaction-click',
    init: function() {
        this.click();
    },
    click: function () {
        $('body').on('click touchstart', supporterInteraction.clickTriggerClass, function() {
            var childId = $(this).data('childid'),
                type = $(this).data('type'),
                contentId  = $(this).data('contentid'),
                pinned  = $(this).data('pinned'),
                childArchived = $(this).data('childarchived');

            supporterInteraction.log(childId, type, contentId, pinned, childArchived);
        });
    },
    log: function (echoChildId, type, contentId, pinned, childArchived) {
        var url = CCM_APPLICATION_URL + "/tools" + '/timeline/log-interaction',
            params = {
                type: type,
                contentId: contentId,
                childId: echoChildId,
                pinned: pinned,
                childArchived: childArchived
            };

        // console.log(url);
        // console.log(params);

        $.ajax({
            method: "GET",
            url: url,
            data: params,
            dataType: 'json',
            async: false
        });
    }
};

$(function () {
    watson.init();
    supporterInteraction.init();
});

function ewtCallback() {
    var ewtInterval,
        attempt  = 0;

    function ewtTimer() {
        attempt++;
        console.log(attempt);

        // stop after 5 seconds or ewt is ready
        if (attempt >= 50 ){
            clearInterval(ewtInterval);
        }

        if (typeof ewt != 'undefined') {
            clearInterval(ewtInterval);
            ewt.init();
            $(document).trigger('ewtready');
        }
    }

    ewtInterval = setInterval(ewtTimer, 100);
}

function oneTrustReady(method, url, element, callback, options, group)
{
    var oneInterval,
        attempt  = 0;

    function oneTimer()
    {
        attempt++;

        // stop after 5 seconds or ewt is ready
        if (attempt >= 50 ) {
            clearInterval(oneInterval);
        }

        if (typeof OneTrust !== 'undefined') {
            clearInterval(oneInterval);
            OneTrust[method](url, element, callback, options, group);
        }
    }

    oneInterval = setInterval(oneTimer, 100);
}